import { AxiosInstance } from 'axios';

import * as common from '../../../../../../typings/api/skymap/rest/v1/.common';
import * as types from '../../../../../../typings/api/skymap/rest/v1/company';

export class CompanyServiceV1 implements types.Handlers {
  constructor(private axios: AxiosInstance) {}

  async attachDongleToCompany(
    params: types.AttachDongleToCompanyParameters,
  ): Promise<types.AttachDongleToCompanyResponse> {
    const { data } = await this.axios.post<types.AttachDongleToCompanyResponse>(
      `/v1/companies/${params.path.companyId}/dongle`,
      {
        ...params.body,
      },
    );
    return data;
  }

  async getAttachedDongles(
    params: types.GetAttachedDonglesParameters,
  ): Promise<common.FetchSkyMapConnectDonglesResponse> {
    const companyId: string = params.path.companyId;
    const { data } = await this.axios.get<common.FetchSkyMapConnectDonglesResponse>(
      `/v1/companies/${companyId}/dongles`,
    );
    return data;
  }

  async removeDongleFromCompany(
    params: types.RemoveDongleFromCompanyParameters,
  ): Promise<types.AttachDongleToCompanyResponse> {
    const { data } = await this.axios.delete<types.AttachDongleToCompanyResponse>(
      `/v1/companies/${params.path.companyId}/dongle`,
      { data: params.body },
    );
    return data;
  }

  async getSkyMapConnectLicenseAgreement(
    params: types.GetSkyMapConnectLicenseAgreementParameters,
  ): Promise<types.GetSkyMapConnectLicenseAgreementResponse> {
    const { data } = await this.axios.get<types.GetSkyMapConnectLicenseAgreementResponse>(
      `/v1/companies/${params.path.companyId}/skymap-connect-license-agreement`,
    );
    return data;
  }

  async createSkyMapConnectLicenseAgreement(
    params: types.CreateSkyMapConnectLicenseAgreementParameters,
  ): Promise<types.GetSkyMapConnectLicenseAgreementResponse> {
    const { data } = await this.axios.post<types.GetSkyMapConnectLicenseAgreementResponse>(
      `/v1/companies/${params.path.companyId}/skymap-connect-license-agreement`,
    );
    return data;
  }
}
